// Height/color normalization scales for the geo explorer. All take a 0..1 normalized input and
// return a 0..1 output, reshaping how the metric maps to column height + color intensity.

export type HeightScale = "linear" | "sqrt" | "log";

// log curve constant — controls how aggressively low values are lifted.
const LOG_K = 9;

export const scaleNorm = (t: number, scale: HeightScale): number => {
  const x = Math.min(1, Math.max(0, t));
  if (scale === "sqrt") {
    return Math.sqrt(x);
  }
  if (scale === "log") {
    return Math.log1p(LOG_K * x) / Math.log1p(LOG_K);
  }
  return x;
};

export const SCALE_OPTIONS: readonly { value: HeightScale; label: string }[] = [
  { value: "linear", label: "Linear" },
  { value: "sqrt", label: "√" },
  { value: "log", label: "Log" },
];
